import { AST } from '@handlebars/parser';
import { NodeType } from '../../../node/types';

export const isStringLiteral = (expression: AST.Node): expression is AST.StringLiteral =>
  expression.type === NodeType.StringLiteral;
